import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const EditarBoletin = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    titulo: "",
    descripcion: "",
    fechaPublicacion: "",
    rutaPdf: "",
  });
  const [archivo, setArchivo] = useState(null);
  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${API}/api/boletines/ver`)
      .then((res) => res.json())
      .then((data) => {
        const b = data.find((b) => b.Id.toString() === id);
        if (b) {
          setForm({
            titulo: b.Titulo,
            descripcion: b.Descripcion,
            fechaPublicacion: b.FechaPublicacion?.split("T")[0],
            rutaPdf: b.RutaPdf,
          });
        }
      })
      .catch((err) => {
        console.error("❌ Error al obtener boletín:", err);
        Swal.fire("❌ Error", "No se pudo cargar la información del boletín.", "error");
      });
  }, [id, API]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
  const file = e.target.files[0];
  const maxSize = 10 * 1024 * 1024; // 10 MB

  if (file && file.size > maxSize) {
    Swal.fire("❌ Archivo demasiado grande", "El archivo debe ser menor a 10 MB.", "error");
    setArchivo(null);
    e.target.value = null; // limpia el input
    return;
  }

  setArchivo(file);
};


  const handleSubmit = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Guardando cambios...",
      text: "Por favor espera mientras se actualiza el boletín.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const formData = new FormData();
      formData.append("titulo", form.titulo);
      formData.append("descripcion", form.descripcion);
      formData.append("fechaPublicacion", form.fechaPublicacion);

      if (archivo) {
        formData.append("archivoPdf", archivo);
      } else {
        formData.append("rutaPdf", form.rutaPdf);
      }

      const res = await fetch(`${API}/api/boletines/editar/${id}`, {
        method: "PUT",
        body: formData,
      });

      if (!res.ok) throw new Error("No se pudo editar el boletín.");

      Swal.close();
      Swal.fire("✅ Boletín actualizado", "Los cambios se guardaron correctamente.", "success");
      navigate(-1);
    } catch (error) {
      Swal.close();
      Swal.fire("❌ Error", error.message, "error");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-xl mx-auto p-6 bg-white shadow rounded">
      <h2 className="text-xl font-bold mb-4">Editar boletín</h2>
      <input
        name="titulo"
        value={form.titulo}
        onChange={handleChange}
        className="w-full p-2 border mb-2 rounded"
        required
      />
      <input
        name="descripcion"
        value={form.descripcion}
        onChange={handleChange}
        className="w-full p-2 border mb-2 rounded"
        required
      />
      <input
        type="date"
        name="fechaPublicacion"
        value={form.fechaPublicacion}
        onChange={handleChange}
        className="w-full p-2 border mb-2 rounded"
        required
      />

      <div className="mb-2">
        <p className="text-sm text-gray-600 mb-1">Archivo actual:</p>
        <a
          href={form.rutaPdf}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline text-sm"
        >
          Ver PDF actual
        </a>
      </div>

      <input
        type="file"
        accept="application/pdf"
        onChange={handleFileChange}
        className="w-full mb-4"
      />
      <p className="text-sm text-gray-500 mb-2">Solo archivos PDF menores a 10MB.</p>


      <button
        type="submit"
        className="bg-yellow-600 text-white px-4 py-2 rounded hover:bg-yellow-700"
      >
        Guardar Cambios
      </button>
    </form>
  );
};

export default EditarBoletin;
